
import $ from 'zepto'
// import ua from './ua'
// import Overlay from './overlay'

let loaded = {}
let $body = $('body')
function load (src, cb) {
  return new Promise((resolve, reject) => {
	if (loaded[src]) {
		return resolve()
	}

	var script = $('<script />')
	script.on('load', function () {
		loaded[src] = true
		resolve()
	})
	script.on('error', function (error) {
		reject(error)
	})
	script.attr('src', src)
	script.appendTo($body)
  })
}
module.exports = {
  load: function () {
    return load('https://s3.pstatp.com/toutiao/tmajssdk/jssdk-1.0.1.js')
      .then(function () {
      }).catch(function () {
        console.log('api加载失败')
      })
  },
  showShareHint: function(popText, popLink, popTip) {
    // TODO:
    // if (ua.isPiaoniuTiktokMiniProgram()) {
    //   let overlay = new Overlay();
    //   let hint = $(`<img src="${require("ui/img/share-hint.png")}" />`);
    //   hint.css({
    //     position: "fixed",
    //     top: 10,
    //     right: ua.isAliMiniProgram() ? 80 : 30,
    //     width: 255,
    //     zIndex: 130
    //   });
    //   hint.appendTo($("body"));
    //   overlay.show();
    //   hint.on("click", () => {
    //     overlay.remove();
    //     hint.remove();
    //   });
    //   overlay.on("tap", () => {
    //     overlay.remove();
    //     hint.remove();
    //   });
    // }
  },
}



// WEBPACK FOOTER //
// ./src/mods/tiktokApi.js